import { NewTransactionAdvancedFormType } from '@malesia/react-components/dist/src/components/Accounting/NewTransaction/NewTransactionAdvanced';
import { NewTransactionPreset, NewTransactionPresetProps } from '@malesia/react-components/dist/src/components/Accounting/NewTransaction/NewTransactionPreset';
import { getAccountListItemDisplayName } from '@malesia/react-components/dist/src/components/Form/Field/SearchAccount/utils';
import { SFC } from '@malesia/react-components/dist/src/types/react';
import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { GetAccountFreeListParams } from '../../../services/account';
import { selectPaymentTypeList } from '../store/selectors';
import { newTransactionActions } from '../store/slice';
import { useTabInfo } from '../useTabInfo';

const debitRequest: GetAccountFreeListParams = {
    accountAssignedType: ['virtual'],
    virtualAssignedType: ['bank'],
};
const creditRequest: GetAccountFreeListParams = {
    accountAssignedType: ['agent'],
};

export const ChargeAccountTab: SFC = () => {
    const dispatch = useDispatch();

    const { myAccount, validateForm, config } = useTabInfo({
        debitRequest,
        creditRequest,
        debitWithMyAccount: true,
    });

    const paymentTypeList = useSelector(selectPaymentTypeList);
    const initValues = useMemo((): Partial<NewTransactionAdvancedFormType> => ({
        debit: myAccount,
        category: paymentTypeList.find(x => x.value === 'prepaid_deposit'),
    }), [myAccount, paymentTypeList]);

    const submit = useCallback((data: NewTransactionAdvancedFormType) => {
        const debitName = getAccountListItemDisplayName(data.debit);
        const creditName = getAccountListItemDisplayName(data.credit);
        dispatch(newTransactionActions.submitAdvancedForm({
            ...data,
            description: `${data.amount} CHF was charged on account for ${debitName} (${data.debit?.id}) by ${creditName}. ${data.description}`,
        }));
    }, [dispatch]);

    const newTransactionPresetProps: NewTransactionPresetProps = {
        config,
        validateForm,
        propsValues: initValues,
        submit,
    };
    return (
        <NewTransactionPreset {...newTransactionPresetProps} />
    );
};
